import React from "react"
import { Route, useRouteMatch } from "react-router-dom"

import CompositionDetail from "./containers/CompositionDetail"
import CompositionList from "./containers/CompositionList"
import CompositionNew from "./containers/CompositionNew"
import CompositionTypeContext, {
  CompositionTypeConfig,
  WASTE_ORIGIN_CONFIG,
} from "./CompositionTypeContext"

interface Props {
  config?: CompositionTypeConfig
}

const Compositions: React.FC<Props> = ({ config = WASTE_ORIGIN_CONFIG }) => {
  const { path } = useRouteMatch()
  return (
    <CompositionTypeContext.Provider value={config}>
      <Route exact path={path}>
        <CompositionList />
      </Route>
      <Route exact path={`${path}/new`}>
        <CompositionNew />
      </Route>
      <Route exact path={`${path}/show/:id`}>
        <CompositionDetail />
      </Route>
    </CompositionTypeContext.Provider>
  )
}

export default Compositions
